import Vue from "vue";
import VueRouter from "vue-router";
import { Toast } from "vant";
import store from "@/store";
import { getToken } from "@/utils/auth"; // getToken from cookie

Vue.use(VueRouter);

const whiteList = ["/dev"];

const routes = [
  {
    path: "/",
    name: "Index",
    component: (resolve) => require(["@/views/index"], resolve),
  },
  {
    path: "/project",
    name: "Project",
    component: (resolve) => require(["@/views/project/index"], resolve),
    meta: { title: "项目总览" },
  },
  {
    path: "/PipelineClassification",
    name: "PipelineClassification",
    component: (resolve) =>
      require(["@/views/project/PipelineClassification"], resolve),
    meta: { title: "项目管线分类" },
  },
  {
    path: "/project/detail/:id",
    name: "ProjectDetail",
    component: (resolve) => require(["@/views/project/detail"], resolve),
    meta: { title: "项目详情" },
  },
  {
    path: "/project/stage/detail/:stageId",
    name: "ProjectStageDetail",
    component: (resolve) => require(["@/views/project/stage/detail"], resolve),
    meta: {
      title: "阶段详情",
    },
  },
  {
    path: "/project/stage/detail/:stageId",
    name: "ProjectStageDetail",
    component: (resolve) => require(["@/views/project/stage/detail"], resolve),
    meta: {
      title: "阶段详情",
    },
  },
  // {
  //   path: "/project/task/:stageId",
  //   name: "ProjectTasks",
  //   component: (resolve) => require(["@/views/project/task/index"], resolve),
  //   meta: { title: "任务列表" },
  // },
  {
    path: "/project/risk/:projectId",
    name: "ProjectRisk",
    component: (resolve) => require(["@/views/project/risk/index"], resolve),
    meta: { title: "项目风险" },
  },
  {
    path: "/project/task/detail/:id",
    name: "ProjectTaskDetail",
    component: (resolve) => require(["@/views/project/task/detail"], resolve),
    meta: { title: "任务详情" },
  },
  {
    path: "/project/task/mine",
    name: "ProjectTaskMine",
    component: (resolve) => require(["@/views/project/task/mine"], resolve),
    meta: { title: "我的任务" },
  },
  {
    path: "/project/task/experiment/:taskId?",
    name: "ProjectExp",
    component: (resolve) =>
      require(["@/views/project/experiment/index"], resolve),
    meta: { title: "实验记录" },
  },
  {
    path: "/project/task/addProgress/:taskId",
    name: "ProjectProgressAdd",
    component: (resolve) => require(["@/views/project/progress/add"], resolve),
    meta: { title: "新增进度记录" },
  },
  {
    path: "/project/task/progress/:taskId",
    name: "ProjectProgress",
    component: (resolve) =>
      require(["@/views/project/progress/index"], resolve),
    meta: { title: "进度记录" },
  },
  {
    path: "/project/task/progress/detail/:progressId",
    name: "ProjectTasksProgressDetail",
    component: (resolve) =>
      require(["@/views/project/progress/detail"], resolve),
    meta: { title: "进度记录详情" },
  },
  {
    path: "/project/task/risk/:taskId?",
    name: "ProjectTasksRisk",
    component: (resolve) => require(["@/views/project/risk/index"], resolve),
    meta: { title: "任务风险" },
  },
  {
    path: "/project/risk/detail/:riskId",
    name: "ProjectRiskDetail",
    component: (resolve) => require(["@/views/project/risk/detail"], resolve),
    meta: { title: "风险记录详情" },
  },
  {
    path: "/project/experiment/detail/:id",
    name: "ProjectExperimentDetail",
    component: (resolve) =>
      require(["@/views/project/experiment/detail"], resolve),
    meta: { title: "实验记录详情" },
  },
  {
    path: "/testing/detail/:id",
    name: "TestingDetail",
    component: (resolve) => require(["@/views/testing/detail"], resolve),
    meta: { title: "检测详情" },
  },
];

if (window.config.env === "development") {
  routes.push({
    path: "/dev",
    name: "Dev",
    component: (resolve) => require(["@/views/dev"], resolve),
  });
}

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

router.beforeEach((to, from, next) => {
  console.log("开始路由检测：", to.path);
  const login = () => {
    try {
      if (window.config.env === "development") {
        next("/dev");
      } else if (window.dd) {
        console.log("开始钉钉登录");
        window.dd.showLoading({
          content: "正在登录…",
        });
        store
          .dispatch("DingtalkLogin")
          .then(() => {
            next();
          })
          .catch((err) => {
            window.dd.alert({
              title: "登录失败",
              content: err?.message,
              buttonText: "我知道了",
            });
          })
          .finally(() => {
            window.dd.hideLoading();
          });
      } else {
        alert("钉钉环境未初始化");
        store.dispatch("LogOut").then(() => {
          location.reload(); // 为了重新实例化vue-router对象 避免bug
        });
      }
    } catch (e) {
      alert("Error: " + e.message);
    }
  };

  if (to.meta.title) document.title = to.meta.title;
  const token = getToken();
  if (token) {
    console.log("已登录：", token);
    // 已登录
    if (store.getters.roles.length === 0) {
      // 判断是否已获取用户信息，如未获取则获取用户信息
      console.log("未获取用户信息，开始获取");
      store
        .dispatch("GetInfo")
        .then(() => {
          console.log("已获取用户信息");
          next();
        })
        .catch(() => {
          login();
        });
    } else {
      console.log("已获取用户信息");
      let title = "修实生物医药";
      if (to.meta?.title) {
        title = to.meta.title;
      }
      if (window.dd) {
        window.dd.setNavigationTitle({ title });
      } else {
        document.title = title;
      }
      next();
    }
  } else {
    if (whiteList.indexOf(to.path) !== -1) {
      // 在免登录白名单，直接进入
      next();
    } else {
      login();
    }
  }
});

export default router;
